import { render, staticRenderFns } from "./Recruit.vue?vue&type=template&id=83da01d2&scoped=true&"
import script from "./Recruit.vue?vue&type=script&lang=js&"
export * from "./Recruit.vue?vue&type=script&lang=js&"
import style0 from "./Recruit.vue?vue&type=style&index=0&id=83da01d2&prod&lang=css&"
import style1 from "./Recruit.vue?vue&type=style&index=1&id=83da01d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83da01d2",
  null
  
)

export default component.exports